import React, { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { company } from "../mock";

export default function FloatingCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // Runs once on mount to attach a single scroll listener.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`fixed bottom-[max(1rem,env(safe-area-inset-bottom))] inset-x-3 sm:inset-x-4 z-40 lg:hidden transition-all duration-300 ${show ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"}`} data-testid="mobile-sticky-cta">
      <div className="flex gap-3 rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-slate-200">
        <a href={company.phoneHref} className="flex flex-1 items-center justify-center gap-2 rounded-xl border-2 border-[#1B45C4] py-3 font-semibold text-[#1B45C4]" data-testid="mobile-sticky-call">
          <Phone className="w-5 h-5" /> Ring
        </a>
        <a href="#kontakt" className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#1B45C4] py-3 font-semibold text-white" data-testid="mobile-sticky-quote">
          <MessageSquare className="w-5 h-5" /> Offert · 20%
        </a>
      </div>
    </div>
  );
}
